var Config = {
   LIMIT: "10",
   PERSIST_SECRET_KEY: "casita-prod12",
   ENVIRONMENT: "PRODUCTION",
   ENVIRONMENTS: {
      LOCAL: {
         API_URL: "https://api.casitatraveltrailers.com/v1",
         DOMAIN_URL: "https://admin.casitatraveltrailers.com",
         CONFIGURATOR_WEB_URL: "https://configurator.casitatraveltrailers.com",
      },
      DEVELOPMENT: {
         API_URL: "https://api.casitatraveltrailers.com/v1",
         DOMAIN_URL: "https://admin.casitatraveltrailers.com",
         CONFIGURATOR_WEB_URL: "https://configurator.casitatraveltrailers.com",
      },
      STAGING: {
         API_URL: "https://api.casitatraveltrailers.com/v1",
         DOMAIN_URL: "https://admin.casitatraveltrailers.com",
         CONFIGURATOR_WEB_URL: "https://configurator.casitatraveltrailers.com",
      },
      DEMO: {
         API_URL: "https://api.casitatraveltrailers.com/v1",
         DOMAIN_URL: "https://admin.casitatraveltrailers.com",
         CONFIGURATOR_WEB_URL: "https://configurator.casitatraveltrailers.com",
      },
      PRODUCTION: {
         API_URL: "https://api.casitatraveltrailers.com/v1",
         DOMAIN_URL: "https://admin.casitatraveltrailers.com",
         CONFIGURATOR_WEB_URL: "https://configurator.casitatraveltrailers.com",
      },
   },
}

Config.env = () => {
   return Config.ENVIRONMENTS[Config.ENVIRONMENT]
}

export default Config